const statusColors = [
  { statuses: ["Funnel"], color: "bg-indigo-200" },
  { statuses: ["In Review"], color: "bg-gray-500" },
  { statuses: ["Analysis"], color: "bg-fuchsia-400" },
  { statuses: ["Backlog"], color: "bg-blue-500" },
  { statuses: ["In Progress"], color: "bg-yellow-500" },
  { statuses: ["Waiting"], color: "bg-red-500" },
  { statuses: ["In Validation"], color: "bg-orange-500" },
  { statuses: ["In Deployment"], color: "bg-purple-500" },
  { statuses: ["Closed", "Resolved"], color: "bg-green-500" },
];

export default statusColors;
